import type { ReactNode } from 'react';
import { cn } from '@uconnect/assets/lib/utils';
import Icon from '@uconnect/assets/components/ui/icon';

interface FeatureProps {
	icon: string;
	title: string;
	variant?: 'search' | 'admin';
	children: ReactNode;
}

export default function Feature( { icon, title, variant = 'search', children }: FeatureProps ) {
	return (
		<div className={ cn( 'flex', variant === 'admin' ? 'gap-2.5' : 'gap-2' ) }>
			<Icon
				name={ icon }
				className={ cn(
					'shrink-0 mt-0.5 text-primary',
					variant === 'admin' ? 'size-4.5' : 'size-5'
				) }
			/>
			<div>
				<div className={ cn(
					'font-semibold! mb-1! text-sm',
					variant === 'admin' ? 'text-primary' : 'text-pretty'
				) }>
					{ title }
				</div>
				<div className="text-muted-foreground text-pretty text-xs">
					{ children }
				</div>
			</div>
		</div>
	);
}
